/***
 * Created on 2024/3/28
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ic_sys_info_svg from '../../static/img/utils/ic-sys-info.svg';
import {Tooltip} from "react-tooltip";
import {useTranslation} from "react-i18next";
import {useOnChange} from "common/Hook";
import QnapAuthAppTimer from "./qnap_auth_app_timer";
import QnapAuthCheckStatus from "./qnap_auth_check_status";

function QnapAuthApprovalVerificationComponent({isObserver, onLaunchQnapAuth, signout, otherWay, twoStepInfo}) {
    const { t } = useTranslation();
    const cur_url = new URL(location.href);
    const {values, setValues, onChange} = useOnChange({
        code: "",
        trust_device: true
    });
    console.log(twoStepInfo.data);

    const getTimerLeft = () => {
        let timer = twoStepInfo?.data?.current_qnap_auth_method?.expires;
        if (!timer) {
            return undefined;
        }
        timer = timer ? parseInt(timer) : 0;
        const current = new Date().getTime();
        const left = Math.round(timer - current) / 1000;
        // return left <= 0 ? 0 : left;
        return left;
    }

    const onCountDownToZero = () => {
         location.href = `/signout${location.search}`;
    }

    return (
        <>
            <div className="common-page-body">
                <div className="two-step--verify">
                    <div className="two-step--verify__action">
                        <p>{t('@The login request has been sent to your mobile device. Approve the request with the "QNAP Authenticator" app.@')}</p>

                        {
                            cur_url.searchParams.get('qauth_app')?.toLowerCase() === "true" &&
                            <p>
                                <button className="q-btn q-btn--default btn-rounded-full btn-tiny"
                                        onClick={onLaunchQnapAuth}>{t('@Launch QNAP Authenticator@')}</button>
                            </p>
                        }

                        <p className="two-step--verify__action__code !text-48 !line-height-normal">{twoStepInfo?.data?.current_qnap_auth_method?.passcode}</p>
                        <div className="comp-add-ons">
                            <div className="countdown-timer">
                                <div className="countdown-timer__ic"></div>
                                <QnapAuthAppTimer class_name={"countdown-timer__time"} init_time={getTimerLeft()} endAction={onCountDownToZero}/>
                            </div>
                        </div>
                    </div>
                </div>

                <p className="!mb-10"><a href='' onClick={otherWay}>{t('@Other ways to get a verification code@')}</a></p>

                <QnapAuthCheckStatus enable={getTimerLeft() > 0}/>
            </div>
            <div className="common-page-footer">
                <div className="q-btn-group btn-align-right">
                    <button className="q-btn q-btn--default btn-medium btn-rounded-normal" onClick={signout}>{t('@Back@')}</button>
                </div>
            </div>
        </>
    );
}

export default QnapAuthApprovalVerificationComponent;